__turbopack_context__.v({
  "arrow": "locateServices-module-scss-module__inh_ra__arrow",
  "btn-con": "locateServices-module-scss-module__inh_ra__btn-con",
  "desc": "locateServices-module-scss-module__inh_ra__desc",
  "disabled": "locateServices-module-scss-module__inh_ra__disabled",
  "locate-hsp-con": "locateServices-module-scss-module__inh_ra__locate-hsp-con",
  "section-con": "locateServices-module-scss-module__inh_ra__section-con",
  "section-title": "locateServices-module-scss-module__inh_ra__section-title",
  "sections": "locateServices-module-scss-module__inh_ra__sections",
  "selected": "locateServices-module-scss-module__inh_ra__selected",
  "title-desc-con": "locateServices-module-scss-module__inh_ra__title-desc-con",
});
